import firebase from 'firebase/app';
import 'firebase/auth';
import Wallkit from './wallkit.esm.min';
import {EventBus} from "../utils/event-bus";
import api from '../utils/axios';
import debug from '../utils/debug';

const firebaseDefaultConfig = {
  apiKey: process.env.MIX_FB_API_KEY,
  authDomain: process.env.MIX_FB_AUTH_DOMAIN,
  databaseURL: process.env.MIX_FB_DATABASE_URL,
  projectId: process.env.MIX_FB_PROJECT_ID,
  storageBucket: process.env.MIX_FB_STORAGE_BUCKER,
  messagingSenderId: process.env.MIX_FB_MESSAGING_SENDER_ID,
  appId: process.env.MIX_FB_APP_ID,
  measurementId: process.env.MIX_MEASUREMENT_ID,
};

function initialize(settings) {
  let config = settings ? settings : firebaseDefaultConfig;

  firebase.initializeApp(config);
  firebase.removeSavedAccountFromStorage = () => {
    const key = 'firebaseui::rememberedAccounts';

    if (Wallkit.isLocalStorageAvailable) {
      if (window.localStorage.getItem(key)) {
        window.localStorage.removeItem(key);
      }
    }
  };
}

async function fetchFirebaseAccountSettings() {
  try {
    let {data} = await api.get(`firebase/account`);

    let config = null;
    if (data && data.web_app_config) {
      config = data.web_app_config.settings;
    }

    initialize(config);

    return true;
  } catch (error) {
    debug.log('FIREBASE INITIALIZATION ERROR:', error);

    return false;
  }
}

export default {
  install: async (Vue) => {
    await fetchFirebaseAccountSettings();
    Vue.prototype.$firebase = firebase;

    if (Wallkit.isLocalStorageAvailable) {
      EventBus.$emit('firebase-init');
    }
  }
};



// WEBPACK FOOTER //
// ./src/plugins/firebase.js